<template>
    <div>
        <v-card elevation="0">
            <v-card-title>Submitted Applications</v-card-title>
            <v-card-subtitle>
                <v-icon small>mdi-information-box-outline</v-icon>&nbsp;Please note that only those applicants selected to move forward in the recruitment process will be contacted.<br />
                <v-icon small>mdi-format-list-numbered</v-icon>&nbsp;Latest submission comes on top.
            </v-card-subtitle>
            <v-card-text>
                <v-data-table
                    :headers="headers"
                    :items="applications"
                    :loading="tableloading"
                    loading-text="Calling application data..."
                    :search="search"
                    :items-per-page="10"
                >
                    <template v-slot:item.view="{ item }">
                        <v-icon
                            class="mr-2"
                            @click="viewApplication(item)"
                        >
                            mdi-eye
                        </v-icon>
                    </template>
                    <template v-slot:no-data>
                        <v-container style="height: 300px;">
                            <v-row
                                class="fill-height"
                                align-content="center"
                                justify="center"
                            >
                                <v-col
                                    class="text-subtitle-1 text-center"
                                    cols="12"
                                >
                                    No Applications
                                </v-col>
                            </v-row>
                        </v-container>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
        <v-dialog
            v-model="dialog"
            fullscreen
            persistent
        >
            <v-card elevation="0">
                <v-toolbar color="#004236" dark>
                    <v-toolbar-title>View Application for {{ selectedApplication.discipline }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="dialog = false">
                        <v-icon>mdi-close-thick</v-icon>
                    </v-btn>
                </v-toolbar>
                <ViewDetails :item="selectedApplication" v-if="dialog"/>
            </v-card>
        </v-dialog>
        <v-snackbar
            v-model="snackbar"
            :color="snackbarcolor"
            :timeout="timeout"
        >
            {{ text }}
        </v-snackbar>
    </div>
</template>
<script>
import ViewDetails from "./ViewDetails.vue"
import auth from '@/js/auth'
export default {
    components: {
        ViewDetails
    },
    data(){
        return {
            host: location.hostname.toString(),
            tableloading: true,
            search: '',
            headers: [
                { text: 'Term', value: 'term'},
                { text: 'Subject', value: 'discipline'},
                { text: 'Course Codes', value: 'coursesText'},
                { text: 'Submitted', value: 'submittedtime'},
                { text: 'View', value: 'view', sortable: false},
            ],
            applications: [],
            selectedApplication: {},
            dialog: false,
            snackbar: false,
            snackbarcolor: "",
            text: "",
            timeout: 3500,
        }
    },
    methods: {
        getApplicationList(){
            const that = this;

            //Session Reading
            let uid = "";
            if(sessionStorage.getItem('cupeapp_aaa')){
                uid = auth.get_impersonated_user()["uid"];
                
            }else {
                uid = auth.get_user()["uid"];
            }

            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=getMyapplications&data={"uid":"'+uid+'"}';
            that.tableloading = true;
            that.applications = [];

            // GET request
            fetch(api)
                .then(function (response) {
                    // Return json response
                    return response.json();
                })
                .then(function (json) {
                    if (json.result.match(/^OK/i)) {
                        that.modifyData(json.data);
                        that.setSnackbar("Calling applications successful!", "#388E3C"); //green
                        that.tableloading = false;
                    }else {
                        that.setSnackbar("Warning: "+json.message, "#EF6C00"); //orange
                    }
                })
                .catch(function (err) {
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                })
        },
        modifyData(items){
            const that = this;
            var list = [];
            items.forEach(element => {
                let record = {};
                record["applicationid"] = element["id"];
                record["postings"] = element["postings"];
                record["discipline"] = element["discipline"];
                record["cupeposition"] = element["cupeposition"];
                record["legaltowork"] = element["legaltowork"];
                record["generalinfo"] = element["generalinfo"];
                record["employment"] = element["employment"];
                record["education"] = element["education"];
                record["references"] = element["references"];
                record["fileCV"] = that.getFilename(element["fileCV"]);
                if(element.hasOwnProperty("suppletype1")){
                    record["filesupple1"] = that.getFilename(element["filesupple1"]);
                    record["suppletype1"] = element["suppletype1"];
                }
                if(element.hasOwnProperty("suppletype2")){
                    record["filesupple2"] = that.getFilename(element["filesupple2"]);
                    record["suppletype2"] = element["suppletype2"];
                }
                record["submittedTimestamp"] = element["submittedTimestamp"];
                record["submitYear"] = element["submitYear"];
            
                record["name"] = element["generalinfo"]["firstname"]+" "+element["generalinfo"]["lastname"];
                record["submittedtime"] = that.convertTime(element["submittedTimestamp"]);
                record["term"] = that.resolveTerm(element["postings"][0]["strm"]);
                //Courses
                var postinglist = "";
                var coursesList = "";
                var sectionsList = "";
                element["postings"].forEach(e => {
                    postinglist += e["title"]+", ";
                    var courselist = "";
                    var sectionsText = "";

                    e["courses"].forEach(c =>{
                        if(c["ssrcomponent"] == "LEC"){
                            courselist += c["catalognbr"]+", ";
                            sectionsText += c["classsection"]+", ";
                        }
                    });

                    coursesList += courselist.slice(0,-2)+" / ";
                    sectionsList += sectionsText.slice(0,-2)+" / ";
                });

                record["postinglist"] = postinglist.slice(0,-2);
                record["coursesText"] = coursesList.slice(0,-3);
                record["sectionsText"] = sectionsList.slice(0,-3);

                list.push(record);
            });
            
            that.applications = list.sort((a,b) => parseInt(b.submittedTimestamp)-parseInt(a.submittedTimestamp));
        },
        getFilename(file){
            return file.split("\\").slice(-1)[0]
        },
        convertTime(time){
            let date = new Date(parseFloat(time));

            return date.toDateString()+", "+String(date.getHours()).padStart(2, '0')+":"+String(date.getMinutes()).padStart(2, '0')+":"+String(date.getSeconds()).padStart(2, '0');
        },
        resolveTerm(stream){
            const that = this;
            let term = stream.slice(-1);
            var year = stream[1]+stream[2];
            var year2 = (parseInt(year)+1).toString();
            var century = (parseInt(stream[0])-1).toString();
            if(term == "9"){
                return "FALL 2"+century+year+"/WINTER 2"+century+year2;
            }else if(term == "5"){
                return "SUMMER 2"+century+year;
            }
        },
        viewApplication(item){
            const that = this;
            that.selectedApplication = item;
            that.dialog = true;
        },
        setSnackbar(msg, color){ //Sets Snackbar
            const that = this;
            that.snackbar = true;
            that.snackbarcolor = color;
            that.text = msg;
        }
    },
    created(){
        const that = this;
        that.getApplicationList();
    }
}
</script>